<!-- 图片加文字描述,点击图片显示大图 -->
<template>
  <div class="row pb-4">
    <div v-for = "item in dataList" :key="item.title"  :class="['col-md-6 col-12 mb-3', item.col ? `col-lg-${item.col}`:'col-lg-4']">
      <div class="shadow-box text-line-height-2 lg-hidden">
        <img :src="item.src" preview class="image-width-100 transform-img " />
        <span class="blue-point font-weight-500 color-dark-grey">{{ item.title }}</span><br />
      </div>
      <div class="shadow-box text-line-height-2 md-hidden" data-bs-toggle="modal" :data-bs-target="'#'+item.title">
        <img :src="item.smSrc"  class="image-width-100 transform-img" />
        <span class="blue-point font-weight-500 color-dark-grey">{{ item.title }}</span><br />
      </div>
      <un-modal  :modalId="item.title" :imgSrc="item.src"></un-modal>
    </div>
  </div>
</template>

<script>
import UnModal from '@/components/Modal.vue';
export default {
  name: 'CardList',
  components: { UnModal },
  props: {
    dataList: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {

  },
  mounted() {
  },
}
</script>
<style scoped>
</style>